import { useEffect, useRef, useState } from "react";
import Slider from "@mui/material/Slider";
import { useTheme } from "@mui/material/styles";
import { GetFontAwesomeIcon } from "../font-awesome-icon";
import {
  faCompress,
  faExpand,
  faVolumeHigh,
  faVolumeMute,
} from "@fortawesome/free-solid-svg-icons";
import { Box } from "@mui/material";
import styles from "./style.module.scss";

// const useStyles = makeStyles((theme) => ({
//   loader: {
//     position: "absolute",
//     top: "0",
//     bottom: "0",
//     display: "flex",
//     alignItems: "center",
//     "& .spinner-border": {
//       width: "4rem",
//       height: "4rem",
//     },
//   },
// }));

const VideoTag = ({
  customClasses,
  controls,
  autoPlay,
  preload,
  src,
  type,
  customStyles = {},
  flush = false,
  ...rest
}) => {
  const videoRef = useRef(null);
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [mute, setMute] = useState(false);
  const [position, setPosition] = useState(0);

  const onFullScreen = (e) => {
    var isFullscreenNow = document.webkitFullscreenElement !== null;
    if (!isFullscreenNow) {
      setFullScreen(false);
    }
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener("webkitfullscreenchange", onFullScreen);
    }

    return () => {
      videoRef?.current?.removeEventListener(
        "webkitfullscreenchange",
        onFullScreen
      );
    };
  }, []);

  const onLoadedData = (e) => {
    // hide loading, when video data loaded
    setLoading(false);
  };

  const onSeekChange = (value) => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = (value / 100) * videoRef.current.duration;
      videoRef.current.play();
      setPosition((value / videoRef.current.duration) * 100);
    }
  };

  const onMouseUp = (value) => {
    // videoRef.current.currentTime = value;
    // videoRef.current.play();
    // setPosition((value / videoRef.current.duration) * 100);
  };

  const muteHandler = (e) => {
    e.stopPropagation();
    console.log("on mute clcik");
    videoRef.current.muted = !mute;
    setMute(!mute);
  };

  const toggleFullScreen = (e) => {
    e.stopPropagation();
    console.log("on toggle fullscreen");
    setFullScreen(!fullScreen);
    if (videoRef.current.mozRequestFullScreen) {
      videoRef.current.mozRequestFullScreen();
    } else if (videoRef.current.webkitRequestFullScreen) {
      videoRef.current.webkitRequestFullScreen();
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        lineHeight: 0,
        overflow: "hidden",
      }}
    >
      {/* visibility hidden when loading and will be visible on loading false */}
      <video
        ref={videoRef}
        controlsList="nodownload noplaybackrate disablepictureinpicture"
        onTimeUpdate={(e) => {
          setPosition((e.target.currentTime / e.target.duration) * 100);
        }}
        className={`${customClasses}`}
        controls={controls}
        autoPlay={autoPlay}
        preload={preload}
        style={{
          visibility: loading ? "hidden" : "visible",
          display: "block",
          ...customStyles,
        }}
        onLoadedData={onLoadedData}
        {...rest}
      >
        <source src={src} type={type}></source>
      </video>
      <Box className={styles.iconContainer}>
        <GetFontAwesomeIcon
          icon={mute ? faVolumeMute : faVolumeHigh}
          iconClass={styles.icon}
          onClick={muteHandler}
        />

        <GetFontAwesomeIcon
          icon={fullScreen ? faCompress : faExpand}
          iconClass={styles.icon}
          onClick={toggleFullScreen}
        />
      </Box>
      <Slider
        aria-label="time-indicator"
        size="small"
        value={position}
        min={0}
        step={1}
        // max={videoRef?.current?.duration}
        max={100}
        onChange={(_, value) => onSeekChange(value)}
        onChangeCommitted={(_, value) => onMouseUp(value)}
        sx={{
          color: theme.palette.mode === "dark" ? "#fff" : "rgba(0,0,0,0.87)",
          height: 3,
          ...(flush
            ? {
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
              }
            : { top: "-15px" }),
          "& .MuiSlider-thumb": {
            width: 8,
            height: 8,
            transition: "0.3s cubic-bezier(.47,1.64,.41,.8)",
            "&::before": {
              boxShadow: "0 2px 12px 0 rgba(0,0,0,0.4)",
            },
            "&:hover, &.Mui-focusVisible": {
              boxShadow: `0px 0px 0px 8px ${
                theme.palette.mode === "dark"
                  ? "rgb(255 255 255 / 16%)"
                  : "rgb(0 0 0 / 16%)"
              }`,
            },
            "&.Mui-active": {
              width: 20,
              height: 20,
            },
          },
          "& .MuiSlider-rail": {
            opacity: 0.28,
          },
        }}
      />
      {/* show loader */}
      {/* {loading && (
        <span className={classes.loader}>
          <Spinner animation="border" variant="secondary" size="lg" />
        </span>
      )} */}
    </Box>
  );
};

export default VideoTag;
